<section class="cookies">
  <h2>Política de Cookies</h2>

  <div class="cookies-content">
    <p>
      En este sitio web utilizamos cookies únicamente para poder mostrar los mapas de Google en la sección de contacto.
      No utilizamos cookies propias de seguimiento, analítica ni publicidad.
    </p>

    <h3>¿Qué son las cookies?</h3>
    <p>
      Una cookie es un pequeño archivo que se descarga en tu ordenador al acceder a determinadas páginas web. 
      Permiten a una página, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación 
      de un usuario o de su equipo.
    </p>

    <h3>Cookies utilizadas en esta web</h3>
    <p>
      Este sitio web únicamente carga cookies de <strong>Google Maps</strong> cuando aceptas el uso de cookies 
      en el aviso mostrado al acceder a la página de contacto.
    </p>
    <ul>
      <li><strong>Proveedor:</strong> Google Ireland Limited</li>
      <li><strong>Finalidad:</strong> Mostrar la ubicación del despacho en el mapa interactivo.</li>
      <li><strong>Más información:</strong> 
        <a href="https://policies.google.com/technologies/cookies?hl=es" target="_blank">
          Política de cookies de Google
        </a>
      </li>
    </ul>

    <h3>Gestión de cookies</h3>
    <p>
      Puedes aceptar o rechazar las cookies de este sitio web mediante el aviso mostrado al acceder a la sección de contacto. 
      Si las rechazas, el mapa no se cargará. También puedes configurar tu navegador para permitir, bloquear o eliminar las 
      cookies instaladas en tu equipo.
    </p>

    <h3>Más información</h3>
    <p>
      Para cualquier duda sobre el uso de cookies en este sitio web, puedes escribirnos a 
      <a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a>.
    </p>
  </div>
</section>
